<template>
  <div class="allocation-rule-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-name">批量规则</span>
        <span class="count-text"
          >已添加账户数量：<span class="count-num">{{ adCount_len }}</span></span
        >
        <el-button type="text" class="edit-btn" @click="showDialog = true"
          ><svg-icon iconClass="edit" className="icon"></svg-icon>编辑</el-button
        >
      </div>
      <div class="header-table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" width="150" label="属性"> </el-table-column>
          <el-table-column prop="num" label="数量"> </el-table-column>
          <el-table-column prop="rule" label="拆分规则"> </el-table-column>
        </el-table>
      </div>
      <div class="header-table-footer">
        预计在<span class="count-num">{{ adCount_len }}</span
        >个账户的<span class="count-num">{{ groupNum }}</span
        >个广告组创建<span class="count-num">{{ planNum }}</span
        >个计划
      </div>
    </div>

    <el-dialog title="分配规则" :visible.sync="showDialog" width="500px" :close-on-click-modal="false" top="8vh">
      <div class="dialog-body">
        <ul class="rule-list">
          <li class="rule-item">
            <span class="rule-label">人群包：</span>
            <el-radio-group v-model="formData.audience" @change="changeRules('audience')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意分类：</span>
            <el-radio-group v-model="formData.creative_category" @change="changeRules('creative_category')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">定向包：</span>
            <el-radio-group v-model="formData.targeting" @change="changeRules('targeting')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">预算与出价：</span>
            <el-radio-group v-model="formData.budget_and_bid" @change="changeRules('budget_and_bid')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意组：</span>
            <el-radio-group v-model="formData.creative_groups" @change="changeRules('creative_groups')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意标题：</span>
            <el-radio-group v-model="formData.title_group" @change="changeRules('title_group')">
              <el-radio label="campaign" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="adset">广告计划</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      showDialog: false,
      formData: {
        audience: "campaign",
        creative_category: "campaign",
        targeting: "campaign",
        budget_and_bid: "campaign",
        creative_groups: "campaign",
        title_group: "campaign",
      },
      groupNum: 0,
      planNum: 0,
      timer: null,
      disableGroup: false,
    };
  },
  methods: {
    changeRules(key) {
      this.$store.commit("set_split_rule", {
        key: key,
        value: this.formData[key],
      });
      this.computedPlan();
    },
    computedPlan() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let groupNum = this.draft_campaign && this.draft_campaign.online_campaign ? this.draft_campaign.online_campaign.length : 1;
        let planNum = 1;
        let numObj = {
          audience: this.rqb_len,
          creative_category: this.cyfl_len,
          targeting: this.dxb_len,
          budget_and_bid: this.ysycj_len,
          creative_groups: this.cyz_len,
          title_group: this.cybt_len,
        };
        for (let [key, value] of Object.entries(this.formData)) {
          if (value === "campaign") {
            //广告组
            groupNum *= numObj[key];
          } else if (value === "adset") {
            //广告计划
            planNum *= numObj[key];
          }
        }
        this.groupNum = this.adCount_len * groupNum;
        this.planNum = this.adCount_len * groupNum * planNum;
      }, 300);
    },
  },
  computed: {
    ...mapState({
      split_rule: (state) => state.Promotion.split_rule,
      draft_campaign: (state) => state.Promotion.draft_campaign,
      adCount_len: (state) => state.Promotion.adCount.length,
      rqb_len: (state) => {
        let list = state.Promotion.draft_adset.audience;
        return list ? list.length : 0;
      },
      cyfl_len: (state) => {
        let list = state.Promotion.draft_ad.creative_category;
        return list ? list.length : 0;
      },
      dxb_len: (state) => {
        let list = state.Promotion.draft_adset.targeting;
        return list ? list.length : 0;
      },
      ysycj_len: (state) => {
        let list = state.Promotion.draft_adset.budget_and_bid;
        return list ? list.length : 0;
      },
      cyz_len: (state) => {
        let list = state.Promotion.draft_ad.creative_groups;
        return list ? list.length : 0;
      },
      cybt_len: (state) => {
        let list = state.Promotion.draft_ad.title_group;
        return list ? list.length : 0;
      },
    }),
    tableData() {
      return [
        {
          name: "人群包",
          num: this.rqb_len,
          rule: this.formData.audience === "adset" ? "广告计划" : this.formData.audience === "campaign" ? "广告组" : "排序分配",
        },
        {
          name: "创意分类",
          num: this.cyfl_len,
          rule:
            this.formData.creative_category === "adset"
              ? "广告计划"
              : this.formData.creative_category === "campaign"
              ? "广告组"
              : "排序分配",
        },
        {
          name: "定向包",
          num: this.dxb_len,
          rule: this.formData.targeting === "adset" ? "广告计划" : this.formData.targeting === "campaign" ? "广告组" : "排序分配",
        },
        {
          name: "预算与出价",
          num: this.ysycj_len,
          rule: this.formData.budget_and_bid === "adset" ? "广告计划" : this.formData.budget_and_bid === "campaign" ? "广告组" : "排序分配",
        },
        {
          name: "创意组",
          num: this.cyz_len,
          rule:
            this.formData.creative_groups === "adset" ? "广告计划" : this.formData.creative_groups === "campaign" ? "广告组" : "排序分配",
        },
        {
          name: "创意标题",
          num: this.cybt_len,
          rule: this.formData.title_group === "adset" ? "广告计划" : this.formData.title_group === "campaign" ? "广告组" : "排序分配",
        },
      ];
    },
  },
  watch: {
    split_rule: {
      handler(value) {
        if (value) {
          let copyData = JSON.parse(JSON.stringify(value));
          this.formData = copyData;
        }
      },
      deep: true,
    },
    draft_campaign(value) {
      if (value && value.online_campaign) {
        //已有广告组
        this.disableGroup = true;

        this.formData.audience === "campaign" && (this.formData.audience = "adset");
        this.formData.creative_category === "campaign" && (this.formData.creative_category = "adset");
        this.formData.targeting === "campaign" && (this.formData.targeting = "adset");
        this.formData.budget_and_bid === "campaign" && (this.formData.budget_and_bid = "adset");
        this.formData.creative_groups === "campaign" && (this.formData.creative_groups = "adset");
        this.formData.title_group === "campaign" && (this.formData.title_group = "adset");
        this.$store.commit("set_allsplit_rule", this.formData);
      } else {
        //新建广告组
        this.disableGroup = false;
      }
      this.computedPlan();
    },
    adCount_len() {
      this.computedPlan();
    },
    rqb_len() {
      this.computedPlan();
    },
    cyfl_len() {
      this.computedPlan();
    },
    dxb_len() {
      this.computedPlan();
    },
    ysycj_len() {
      this.computedPlan();
    },
    cyz_len() {
      this.computedPlan();
    },
    cybt_len() {
      this.computedPlan();
    },
  },
};
</script>

<style lang="less" scoped>
.allocation-rule-wrap {
  .table-wrap {
    width: 100%;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    box-sizing: border-box;
    .table-header {
      display: flex;
      align-items: flex-end;
      .header-name {
        color: rgba(0, 0, 0, 1);
        font-weight: 500;
        font-size: 16px;
        font-weight: bold;
      }
      .count-text {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        line-height: 15px;
        margin-left: 12px;
        .count-num {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
        }
      }
      .edit-btn {
        margin-left: auto;
        color: rgba(24, 144, 255, 1);
        padding: 0px;
        .icon {
          margin-right: 4px;
        }
      }
    }
    .header-table-wrap {
      margin-top: 24px;
      /deep/ th {
        height: 30px;
      }
      /deep/ .el-table__cell {
        padding: 5px 0;
      }
    }
    .header-table-footer {
      padding-top: 10px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      .count-num {
        margin: 0 4px;
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
      }
    }
  }
  .dialog-body {
    .rule-list {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .rule-item {
        margin-top: 20px;
        .rule-label {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          text-align: right;
          padding-right: 2px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
